// @flow
import React from 'react';
import classnames from 'classnames';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ICONS } from 'Components/utils/icon/icons';
import { WebCallbackTrigger } from 'Components/widgets/webcallback/WebCallbackTrigger.jsx';
import { t } from 'Src/i18n';
import { COLORS } from 'Components/utils/color/colors';
import config from 'Config';

type ContactProps = {
  text: string,
  secondaryText: string,
  iconName: string,
  className?: string,
  textLtr?: boolean,
  url?: string,
};

const Contact = ({ text, textLtr, secondaryText, iconName, className, url }: ContactProps) => {
  const Comp = url ? 'a' : 'div';
  const link = url ? { href: url } : undefined;
  return (
    <Comp className={className} {...link}>
      <Icon name={iconName} color={COLORS.BLUE} width="1.875rem" />
      <div className="text-blue">
        <p className="text-xl font-bold m-0" dir={textLtr ? 'ltr' : ''}>
          {text}
        </p>
        <p className={classnames('text-sm m-0', { underline: !url })}>{secondaryText}</p>
      </div>
    </Comp>
  );
};

export function CallCenterBlock() {
  const isWebCallbackEnabled = config.get('freespee.enabled');
  return (
    <div style={{ background: 'rgba(0,85,137,0.05)' }}>
      <div className="text-center p-4">
        <p className="text-2xl text-blue font-brand m-0 mt-4">{t('navigationBar.contact.title')}</p>
        <p className="text-md text-sans">{t('remote.noResult.contactAdvisors')}</p>
        <div className="lg:flex justify-around">
          <Contact
            text={t('navigationBar.contact.phoneNumber')}
            textLtr
            secondaryText={t('navigationBar.contact.toll')}
            url={`tel:${t('navigationBar.contact.phoneNumber')}`}
            iconName={ICONS.PHONE_BUBBLE}
          />
          {isWebCallbackEnabled && (
            <WebCallbackTrigger trackingData={{ actionGA: 'search' }} theme="search">
              <Contact
                text={t('remote.noResult.callBackLabel')}
                secondaryText={t('remote.noResult.callBackSchedule')}
                className="mt-4 lg:mt-0"
                iconName={ICONS.CALLMEBACK}
              />
            </WebCallbackTrigger>
          )}
        </div>
      </div>
    </div>
  );
}
